// extracted by mini-css-extract-plugin
export default {"cardMedia":"aU-z","shopText":"bU-z","videoPlayer":"cU-z","videoContainer":"dU-z"};